import React from 'react';
import { X, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface LogoutConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const LogoutConfirmModal = ({
  isOpen,
  onClose
}: LogoutConfirmModalProps) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    // Simulate logout API call
    setTimeout(() => {
      // In a real app, you would clear authentication tokens here
      // For now, just navigate to login page (assuming it's at '/')
      navigate('/');
      onClose();
    }, 500);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 flex items-center justify-center z-50" data-id="element-1417">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-1418"></div>
      <div className="relative bg-black/90 border border-emerald-500/30 shadow-[0_0_25px_rgba(16,185,129,0.2)] rounded-lg w-full max-w-md mx-4 overflow-hidden" data-id="element-1419">
        <div className="flex justify-between items-center p-6 border-b border-gray-800" data-id="element-1420">
          <h3 className="text-lg font-bold" data-id="element-1421">Çıkış Yap</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1422">
            <X className="h-5 w-5" data-id="element-1423" />
          </button>
        </div>
        <div className="p-6" data-id="element-1424">
          <div className="flex items-center justify-center mb-6" data-id="element-1425">
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-1426">
              <LogOut className="h-8 w-8 text-red-400" data-id="element-1427" />
            </div>
          </div>
          <h3 className="text-xl font-bold text-center mb-2" data-id="element-1428">
            Çıkış Yapmak İstiyor musunuz?
          </h3>
          <p className="text-gray-400 text-center mb-6" data-id="element-1429">
            Hesabınızdan çıkış yapacaksınız. Devam etmek istiyor musunuz?
          </p>
          <div className="flex justify-center space-x-3" data-id="element-1430">
            <button onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg" data-id="element-1431">
              İptal
            </button>
            <button onClick={handleLogout} className="px-4 py-2 bg-gradient-to-r from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 rounded-lg" data-id="element-1432">
              Çıkış Yap
            </button>
          </div>
        </div>
      </div>
    </div>;
};